import React, { useEffect, useRef, useState } from "react";
import * as S from "./AlgorithmsView.style";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import * as Yup from "yup";

// graphQL
import { useMutation } from "@apollo/client";
import { MUTATION_CHAT_BOX } from "../../../../../../../../graphql/mutations/Chat";

// components
// import Message from "../../../../message";
import Message from "../../../../../../algorithms/components/message";
import YesOrNo from "../../../../yesOrNo";
import MessageType from "../../../../messageType";
import ZaialoadingPoints from "../../../../../../../zaiaComponents/zaiaLoadingPoints";

// pipes
import * as P from "../../../../../../../../utils/pipes";

// Hooks
import useDoctorData from "../../../../../../../../hooks/useDoctorData";
import ChatbotInput from "../../../../chatbotInput";
import useSize from "../../../../../../../../hooks/useSize";
import useUploadTempDoc from "../../../../../../../../hooks/useUploadTempDoc";
import useUploadTempSeveralDocs from "../../../../../../../../hooks/useUploadTempSeveralDocs";
import ZaiaImage from "../../../../../../../zaiaComponents/zaiaImage";
import ZaiaReaction from "../../../../../../../zaiaComponents/zaiaReaction";
import useUploadImageProcessor from "../../../../../../../../hooks/useUploadImage";
import useFileProcessor from "../../../../../../../../hooks/useImageProcessor";

const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

function AlgorithmsView({ 
  algorithm, 
  setProgramSelected,
}) {

  const footerRef = useRef();
  const { height } = useSize(footerRef);
  const [messages, setMessages] = useState([]);
  const { t, i18n: { language } }= useTranslation("global");
  const [chatBox, {loading: chatLoading}] = useMutation(MUTATION_CHAT_BOX);
  const { doctorData } = useDoctorData();
  const {tempDoc, dataDoc, errorFormat, uploadTempDoc, deleteDoc} = useUploadTempDoc();
  const [severalFilesSelected, setSeveralFilesSelected] = useState([]);
  const [severalFilesSelectedMessage, setSeveralFilesSelectedMessage] = useState("");
  const {tempDocs, dataDocs, errorFormatDocs, uploadMultiDocs, deleteDocs, errorLimit} = useUploadTempSeveralDocs();
  const {uploadFileProcessor, data, loading, error, cleanAction} = useFileProcessor();  
  const fileInput = useRef(null);
  const [errorUploading, setErrorUploading] = useState(false);

  const element = document.getElementById("chatbot-container");

  useEffect(() => {
    if(algorithm.imgProcessorType === "prostate") {
      patientMessage(t("algorithms.uploadFileImgDcomProstate"));
    } else if(algorithm.imgProcessorType) {
      patientMessage(t("algorithms.uploadFileImgDcom"));
    } else {
      botMessage(algorithm.triggerText);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const patientMessage = (msg, type, file) => {
    let allMessages = messages;
    allMessages.push(
      {
        id: Date.now(),
        message: msg,
        type: type,
        file: file
      }
    )
    setMessages([...allMessages])
  }

  const botMessage = async (msg, setSubmitting, resetForm) => {    
    try {
      if(resetForm) resetForm();
      if(setSubmitting) setSubmitting(false);
      const {
        data: {
          chatBot,
        },
      } = await chatBox({
        variables: {
          message: msg,
          doctorId: doctorData?.id,
        },
      });
      if (!chatLoading) {
        setMessages(
          [...messages,
          {
            id: Date.now(),
            message: chatBot.message,
            payload: chatBot.payload,
            type: 'bot',
          }]
        )
        autoScroll()
      }
    } catch (error) {
      console.log(error);
    }
  }

  const customBotMessage = async (msg, setSubmitting, resetForm, files) => {    
    try {
      if(resetForm) resetForm();
      if(setSubmitting) setSubmitting(false);
      let data = await uploadFileProcessor(files, msg, algorithm.imgProcessorType);
      patientMessage(data.data.analysis, 'patient');
      autoScroll()
    } catch (error) {
      console.log(error);
    }
  }

  const autoScroll = () => {
    if(element) element.scrollTop = element.scrollHeight - element.clientHeight;
  }
    
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {   
    if(tempDoc) {
      console.log(URL.createObjectURL(tempDoc));
      console.log(values);
      patientMessage(values.msg, 'doctor', URL.createObjectURL(tempDoc));
      customBotMessage(values.msg, setSubmitting, resetForm, [tempDoc]);
      deleteDoc();
      autoScroll(); 
    } else {
      patientMessage(values.msg, 'doctor');
      botMessage(values.msg, setSubmitting, resetForm);
      autoScroll();
    }
  };

  const handleSubmitSeveralFiles = async (values, { setSubmitting, resetForm }) => {    
    const docsLength = severalFilesSelected.length + tempDocs.length;
    
    if(docsLength > 0 && docsLength < 4) {      
      setSeveralFilesSelected((prev) => [...prev, ...tempDocs]);
      tempDocs.forEach((doc, index) => {
        patientMessage(
          index === tempDocs.length - 1 ? values.msg : '',
          'doctor', 
          URL.createObjectURL(doc)
        );
      });
      patientMessage(`${
          t("algorithms.completeAnalysis1")} ${4 - docsLength} ${(4 - docsLength) === 1 ? t("algorithms.completeAnalysis2one") : t("algorithms.completeAnalysis2several")
        }`, 
        'patient'
      );
      setSeveralFilesSelectedMessage(values.msg);
      deleteDocs();
      autoScroll();
    } else if(docsLength === 4) {
      tempDocs.forEach((doc, index) => {
        patientMessage(
          index === tempDocs.length - 1 ? values.msg : '',
          'doctor', 
          URL.createObjectURL(doc)
        );
      });
      customBotMessage(values.msg ? values.msg + " " + severalFilesSelectedMessage : severalFilesSelectedMessage, setSubmitting, resetForm, [...severalFilesSelected, ...tempDocs]);
      setSeveralFilesSelectedMessage("");
      setSeveralFilesSelected([]);
      deleteDocs();
      autoScroll();
    }
  };

  return (
    <S.AlgorithmsView
      footerHeight={height}
    >
      <input
        type="file"
        ref={fileInput}
        onChange={(e) => 
          algorithm.imgProcessorType === "prostate"
          ? uploadMultiDocs(e, (4 - severalFilesSelected.length))
          : uploadTempDoc(e)
        }
        style={{display: 'none'}}
        accept="image/*,.dcom"  
        multiple
      />
      {
        !tempDoc && tempDocs.length === 0
        ? <>
          <header>
            <i
              className="icon zaia-icono-atras"
              onClick={() => {
                setProgramSelected(null)
              }}
              style={{ cursor: "pointer" }}
            ></i>
            <div className="rightsideAlgorithms__headerTitle">
              <div className="rightsideAlgorithms__headerIcon">
                <i className={`icon ${algorithm.icon}`}></i>
              </div>
              <h4>
                <strong>{P.dataTranslation(algorithm.processName, language)}</strong>
                {/* - {P.dataTranslation(algorithm.descript, language)} */}
              </h4>
            </div>
            <div></div>
          </header>
          <span>{t("algorithms.chatSelect")}</span>
          <div className="chatbot-container" id="chatbot-container">
            {messages.map((message, index) => (
              <div key={message.id}>
                {
                  message.type === 'yesOrNo'
                  ? <YesOrNo
                    option={message.message}
                    noEditable={true}
                  />
                  : <Message
                    message={message.message}
                    option={message.type}
                    file={message.file}
                  />
                } 
                {
                  message.payload && Object.keys(message.payload).length > 0 
                  && 'items' in message.payload.fields
                  ? <MessageType
                      itemsList={message.payload.fields.items.listValue.values}
                      patientMessage={patientMessage}
                      botMessage={botMessage}
                      autoScroll={autoScroll}
                      message={message}
                      yesOrNoDisabled={messages[`${index + 1}`]?.type !== 'yesOrNo'}
                    /> 
                  : null
                }
              </div>
            ))}
            { 
              chatLoading || loading
              ? <Message>
                <ZaialoadingPoints />
              </Message> 
              : null
            }
          </div>
          {/* <Formik
            initialValues={{
              msg: "",
            }}
            validationSchema={
                Yup.object({
                  msg: Yup.string()
                  .required("Este campo es obligatorio."),
                })
            }
            onSubmit={handleSubmit}
          >
            {(props) => (
              <form
                onSubmit={props.handleSubmit}
                className="messageDisplay__containerFooter"
              >
                <input
                  placeholder={t("globally.writeMessage")}
                  name="msg"
                  type="text"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  value={props.values.msg}
                  autoComplete="off"
                />
                <button type="submit" disabled={props.isSubmitting}>
                  <i className="send-icon icon zaia-send"></i>
                </button>
              </form>
            )}
          </Formik> */}
        </>
        : <div className="file-selected">
          <div className="header">
            <div className="header__close"
              onClick={() => {
                algorithm.imgProcessorType === "prostate"
                ? deleteDocs()
                : deleteDoc();
                fileInput.current.value = null;
              }}
            >
              <i className="icon zaia-icono-cerrar"></i>
            </div>
            <div className="header__info">
              {/* <div className="header__img">
                <ZaiaImage img={selectedChat?.chatPhotoUser} alt="Zaia user" size={40} defaultImg={defaultChatGroup} rounded={true}/>
              </div>
              <div className="header__text">
                <div className="text">
                  {selectedChat?.chatNameUser}
                </div>
                <div className="text">
                  {selectedChat?.userToProcess ? P.dataTranslation(selectedChat?.userToProcess.process?.processName, language) : ""}
                </div>
              </div> */}
            </div>
          </div>
          {
            error || errorLimit ?
            <div className="error-reaction">
              <ZaiaReaction
                zaiaImg={logoZaiaAlert}
                widthimg="100px"
                text={errorLimit ? t("algorithms.errorLimitFiles") : t("chat.errorLoadingFile")}
                sizeText="20px"
                widthText="240px"
              />
            </div>
            : <>
              {
                algorithm.imgProcessorType === "prostate"
                ? <div className="files">
                  {
                    tempDocs.map((doc, index) => {
                      return(
                        <div className="file" key={index}>
                          <div className="file__preview">
                            {
                              doc?.type?.includes("image") 
                              ? <div className="file__img">
                                <img src={
                                  doc?.url || URL.createObjectURL(doc)
                                } alt="" />
                              </div>
                              : <div className="file__icon">
                                <i className="icon zaia-icon-file"></i>
                              </div>
                            }
                          </div>
                          <div className="file__title">
                            {doc?.name || dataDocs[index]?.name || "Archivo"}
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
                : <div className="file">
                  <div className="file__preview">
                    {
                      tempDoc?.type?.includes("image") 
                      ? <div className="file__img">
                        <img src={
                          tempDoc?.url || URL.createObjectURL(tempDoc)
                        } alt="" />
                      </div>
                      : <div className="file__icon">
                        <i className="icon zaia-icon-file"></i>
                      </div>
                    }
                  </div>
                  <div className="file__title">
                    {tempDoc?.name || dataDoc?.name || "Archivo"}
                  </div>
                </div>
              }
            </> 
          }
        </div>        
      }
      <div className="chatbot-footer" ref={footerRef}>
        <ChatbotInput
          handleSubmit={
            algorithm.imgProcessorType === "prostate"
            ? handleSubmitSeveralFiles
            : handleSubmit
          }
          handleClickUpload={() => fileInput.current.click()}
          tempDocs={algorithm.imgProcessorType === "prostate" ? tempDocs : [tempDoc]}
          filesSelectorActived={true}
        />
      </div>
    </S.AlgorithmsView>
  );
};

export default AlgorithmsView;
